import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    rounds: [],
    roundsLoading: false,
    currentRound: {},
    currentRoundLoading: false,
    currentEventRounds: {},
    currentEventRoundLoading: false
  },
  mutations: {
    setRounds(state, payload) {
      state.rounds = payload;
    },
    setRoundsLoading(state, payload) {
      state.roundsLoading = payload;
    },
    setCurrentRound(state, payload) {
      state.currentRound = payload;
    },
    setCurrentRoundLoading(state, payload) {
      state.currentRoundLoading = payload;
    },
    setCurrentEventRounds(state, payload) {
      state.currentEventRounds = payload;
    },
    setCurrentEventRoundsLoading(state, payload) {
      state.currentEventRoundsLoading = payload;
    }
  },
  actions: {
    async loadRounds({ commit }, id) {
      commit("setRoundsLoading", true);
      let response = await api.get("eventProgress/loadRounds", {
        params: { events_id: id }
      });
      commit("setRounds", response.data);
      commit("setRoundsLoading", false);
    },
    async loadCurrentRound({ commit }, id) {
      commit("setCurrentRoundLoading", true);
      let response = await api.get("eventProgress/loadRoundObject", {
        params: { id: id }
      });
      commit("setCurrentRound", response.data);
      commit("setCurrentRoundLoading", false);
    },
    async loadCurrentEventRoundsObject({ commit }, id) {
      commit("setCurrentEventRoundsLoading", true);
      let response = await api.get(
        "eventProgress/loadCurrentEventRoundsObject",
        {
          params: { id: id }
        }
      );
      commit("setCurrentEventRounds", response.data[0]);
      commit("setCurrentEventRoundsLoading", false);
    },
    async submitRegistration({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/registration", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async drawLanes({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/drawLanes", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async drawLanesFinals({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/drawLanesFinals", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    },
    async submitPlacings({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("eventProgress/submit/placings", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      return returnData;
    }
  },
  getters: {
    rounds(state) {
      return state.rounds;
    },
    roundsLoading(state) {
      return state.roundsLoading;
    },
    currentRound(state) {
      return state.currentRound;
    },
    currentRoundLoading(state) {
      return state.currentRoundLoading;
    },
    currentEventRounds(state) {
      return state.currentEventRounds;
    },
    currentEventRoundLoading(state) {
      return state.currentEventRoundLoading;
    }
  }
};
